import { JsonNode } from 'components/RichTextEditor/SuperChargedRte/utils/types'
import { Editor, Text, NodeEntry, Element } from 'slate'

export function getLowestElementAtSelection(editor, selection, excludedElements = []): NodeEntry<JsonNode> | undefined {
  const [lowestElementAtSelection] = Editor.nodes<JsonNode>(editor, {
    at: selection,
    mode: 'lowest',
    match: (node: JsonNode) => Element.isElement(node) && !excludedElements.includes(node.type)
  })

  return lowestElementAtSelection
}